// Corresponds to PaginationRepresentation in API
export class PaginatedResponse<T> {
    totalRecords: number;
    data: T;
}